import { useNotificationNavigation } from "./useNotificationNavigation";

/**
 * Headless bridge that mounts {@link useNotificationNavigation} once inside the
 * authenticated, router-scoped shell. Renders nothing; exists so the listener
 * lives as a sibling of <Routes> and survives route transitions, mirroring the
 * realtime bridges.
 */
export function NotificationNavigationBridge(): null {
    useNotificationNavigation();
    return null;
}
